import { config, user, isLogged, isApp, getFlow } from "../utils";
import { track } from './bi-track';
import { onLoad } from '../utils/onLoad';
import { getUrlParam } from '../utils/url-helper';
var $ = require('jquery');

import { initBIEventListeners } from '../BI/listeners/index'

// Data models tracking (BI & Zendesk)
import { ProductListBIModel, ProductViewBIModel, GenericClickBIModel } from '../BI/models';
import { EVENT_CAROUSEL_SCROLL } from "../events/triggers/carousel-scroll"; // image-product-detail-v2 Cuando acabe el test, o veamos que pasa, eliminar este evento
import { CarouselScrollBIModel } from "../BI/models/CarouselScroll"; // image-product-detail-v2 Cuando acabe el test, o veamos que pasa, eliminar este evento


const getSectionFromUrl = (url) => {

    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch (e) {
        return 'other';
    }

    if (parsedUrl.pathname.includes('configuration')
        || parsedUrl.pathname.includes('rating')
        || parsedUrl.pathname.includes('wallet')) {
        return 'other';
    }

    if (parsedUrl.pathname.startsWith(`/${config.currentVertical.slug}`) && parsedUrl.pathname.includes('_txt-')) {
        return "search";
    } else if (parsedUrl.pathname.startsWith(`/${config.currentVertical.slug}`)) {
        return "filters";
    } else if (parsedUrl.pathname.startsWith('/whotofollow')) {
        return "user_list";
    } else if (parsedUrl.pathname.includes('/search_filter_alert')) {
        return "search_alert";
    } else if (parsedUrl.pathname.startsWith('/home') || parsedUrl.pathname === '/'
        || parsedUrl.pathname.startsWith('/feed') || parsedUrl.pathname.startsWith('/?')) {
        return "feed";
    } else if (parsedUrl.pathname.includes('/wishlist') || parsedUrl.pathname.includes('/favorites')) {
        return "wishlist";
    } else if (parsedUrl.pathname.includes('mis/ventas')) {
        return "my_sales";
    } else if (parsedUrl.pathname.includes('transacciones') || parsedUrl.pathname.includes('transactions')) {
        return "my_buys";
    } else if (parsedUrl.pathname.includes('/profile/new_products')) {
        return "following_feed";
    } else if (parsedUrl.pathname.startsWith('/u/')
                || (parsedUrl.pathname.startsWith('/profile')
                && !parsedUrl.pathname.includes('republish')
                && !parsedUrl.pathname.includes('notifications')
            ))
    {
        return "closet";
    } else if (parsedUrl.pathname.startsWith('/colecciones')) {
        return "collection";
    } else if (parsedUrl.pathname.startsWith('/p/')) {
        return "related";
    } else if (parsedUrl.pathname.includes('/publish')) {
        return "post_publish";
    }

    return 'other';
};

const getTrendView = (url) => {
    const parsedUrl = new URL(url);
    let trendView;

    if (parsedUrl.pathname.startsWith('/home/discover')) { // MUST GO BEFORE /home/ as also starts with /home/
        trendView = "discover";
    } else if (parsedUrl.pathname.startsWith('/profile/configuration')) {
        trendView = "configuration";
    } else {
        trendView = getSectionFromUrl(url);
    }

    return trendView;
};


const extractClosetOwner = (referrer) => {
    const matches = referrer.match(/\/u\/(.*)/);
    return matches ? matches[1] : null;
}

// Product View
const trackProductView = () => {

    if (isLogged()) {
        const productSheetContainer = document.getElementById('product-sheet');
        const productId = parseInt(productSheetContainer?.dataset.idProduct);
        const isSeller = !!(productSheetContainer?.dataset.isOwner);
        const fairPrice = productSheetContainer?.dataset.fairPrice;
        const referrer = document.referrer;
        const lastConnection = parseInt(productSheetContainer?.dataset.lastConnection);
        const timeToAnswer = parseInt(productSheetContainer?.dataset.timeToAnswer);
        const countrySeller = productSheetContainer?.dataset.biCountrySeller;

        const flowData = {
            userId: user.id,
            flow: getFlow(),
            productId: productId,
            currentUrl: location.href,
            referrerUrl: referrer,
            isSeller: isSeller,
            closetOwner: null,
            badge: fairPrice,
            lastConnection: lastConnection,
            timeToAnswer: timeToAnswer,
            countrySeller: countrySeller
        };

        if (flowData.flow === 'closet') {
            flowData.closetOwner = extractClosetOwner(referrer);
        }

        const productViewBIModel = new ProductViewBIModel(...Object.values(flowData));
        track(productViewBIModel);

    }

}

document.addEventListener(EVENT_CAROUSEL_SCROLL, e => { // image-product-detail-v2 Cuando acabe el test, o veamos que pasa, eliminar este evento
    if (isLogged()) {
        track(new CarouselScrollBIModel(user.id, 'img_ficha', parseInt(e.carouselPosition), e.countrySeller));
    }
});

$(document).on('click', '.js-data-generic-clickable', function() {
    if (isLogged()) {
        track(new GenericClickBIModel(user.id, this.dataset.action));
    }

    if (this.dataset.link != null){
        window.location.href = this.dataset.link;
    }
});

const trendView = getTrendView(location.href);
const relatedProductElement = document.getElementById('related-products');
const hasRelatedProductElement = isLogged() && ['related'].includes(trendView) && !!relatedProductElement?.innerHTML?.trim();
const currencyToCountryISO = currency => {
    if (!currency) return config.country;
    switch(currency.toUpperCase()) {
        case 'MXN': return 'mx';
        case 'COP': return 'co';
        case 'USD': return 'us';
        default: return config.country;
    }
};
//Evento product_list usando obsever API (listas y feeds)
if (
    isLogged() &&
    (['search', 'home', 'feed', 'following_feed', 'filters', 'closet', 'wishlist', 'collection', 'search_alert'].includes(trendView) || hasRelatedProductElement)
) {
    const MIN_IMPRESSION_TIME_MS = 1000; //Tiempo minimo para considerar un producto visto
    const ELEMENT_VISIBILITY_RATE = 0.75; //Que % de la card ha de ser visible al menos
    const SEND_INTERVAL_MS = 5000;
    let buffer = {}; //Elementos que han estado al menos un segundo visibles y todavía no hayamos enviado
    const currentProducts = {}; //Anotamos la fecha y labels en la que comenzamos a ver cada producto usando el observer
    let scrollNum = 0;

    const elementFromProduct = productId => document.querySelector(`[data-bi-product-view="${productId}"]`);

    const intersectionChangeCallback = (entries, observer) => {
        entries.forEach((entry) => {
            const productId = entry.target.dataset.biProductView;
            const countryISO = currencyToCountryISO(entry.target.dataset.biSellerCurrency);
            if(entry.isIntersecting) {
                currentProducts[productId] = { 
                    timestamp: new Date().getTime(), 
                    label: 
                        (entry.target.querySelector('.ico-flame')? 'ganga' : null ) ||
                        entry.target.querySelector('[data-bi-label]')?.dataset?.biLabel ||
                        entry.target.querySelector('.js-bi-label')?.innerText?.trim(),
                    countryISO: countryISO
                };
            } else if(productId in currentProducts) {
                bufferCheck(new Date().getTime(), productId, observer);
                delete currentProducts[productId];
            }
        });
    };

    //Comprueba y envia el producto al buffer, si aplica
    const bufferCheck = (currentTime, productId, observer) => {
        if(currentTime - currentProducts[productId].timestamp > MIN_IMPRESSION_TIME_MS) {
            buffer[productId] = currentProducts[productId];
            //una vez se encola al buffer, ya no hace falta seguir observandolo ni nada
            const element = elementFromProduct(productId);
            if(element) {
                observer.unobserve(element);
            }
            delete currentProducts[productId];
        }
    };

    const intersectionObserver = new IntersectionObserver(
        intersectionChangeCallback,
        { root: null, rootMargin:'0px', threshold: [ELEMENT_VISIBILITY_RATE] }
    );

    // cuando consideremos, miramos que productos se han estado viendo por mas de X tiempo y los enviamos
    const sendBuffered = (observer) => {
        //Chequeamos productos visibles, porque quizas ya los podemos enviar en este tic
        const currentTime = new Date().getTime();
        for (const productId in currentProducts) {
            bufferCheck(currentTime, productId, observer);
        }
        if(!Object.keys(buffer).length) {
            return;
        }
        sendProductListEvent(buffer);
        buffer = {};
    };
    const observeProducts = (observer) => document.querySelectorAll('[data-bi-product-view]:not(.js-bi-observed)').forEach(
        element => {
            observer.observe(element);
            element.classList.add('js-bi-observed');
        }
    );

    const sendProductListEvent = products => {
        const gridColumns = document.getElementById('grid-columns-selector')?.value;
        const eventData = Object.assign(
            {
                user_id: user.id,
                count: Object.keys(products).length,
                current_url: location.href,
                grid_view: parseInt(gridColumns ?? config?.gridColumnsDefault, 10),
                is_seller: false,
                page: null,
                products: Object.keys(products).map(productId => parseInt(productId, 10)),
                timestamps: Object.values(products).map(entry => entry.timestamp),
                labels: Object.values(products).map(entry => entry.label),
                referrer_url: document.referrer,
                flow: getFlow(),
                total: null,
                brand_filter: null,
                category_filter: null,
                color_filter: null,
                max_price_filter: null,
                min_price_filter: null,
                query: null,
                size_filter: null,
                sort: null,
                status_filter: null,
                section_name: null,
                countries_seller: Object.values(products).map(entry => entry.countryISO)
            },
            config?.currentSearchFilters || {}
        );

        if (['closet', 'wishlist'].includes(trendView)) {
            let isSellerContainer = document.querySelector('.bi-is-seller');
            if (isSellerContainer) {
                eventData.is_seller = !!isSellerContainer.dataset.isSeller
            }
        }
        if( document.querySelector('.js-infinite-scroll .pagination')) {
            eventData.page = scrollNum;
        }

        if (hasRelatedProductElement) {
            eventData.section_name = 'related';
        }

        if (['search_alert'].includes(trendView)) {
            const alertData = document.querySelector('.js-search-filter-alert-data');
            const categories = alertData?.dataset.filterCategories || null;
            const brands = alertData?.dataset.filterBrands || null;
            brands !== null && (eventData.brand_filter = brands);
            categories !== null && (eventData.category_filter = categories);
        }
        track(new ProductListBIModel(...Object.values(eventData)));
    };

    //Cada 3 segundos enviamos evento si es necesario, y tb al perder visibilidad
    setInterval(() => sendBuffered(intersectionObserver), SEND_INTERVAL_MS);
    document.addEventListener("visibilitychange", () => sendBuffered(intersectionObserver));
    document.addEventListener('infinite-scroll-load', () => {
        observeProducts(intersectionObserver);
        scrollNum++;
    });

    onLoad(() => {
        // Evento product_list para productos relacionados en ficha (caso especial)
        if (hasRelatedProductElement) {
            const relatedNodes = relatedProductElement?.querySelectorAll('[data-bi-product-view]') ?? [];
            if (!relatedNodes.length) {
                return;
            }
            const now = Date.now();
            const products = {};
            relatedNodes.forEach(node => {
                const productId = node.dataset.biProductView;
                const countryISO = currencyToCountryISO(node.dataset.biSellerCurrency);
                const label =
                    (node.querySelector('.ico-flame') ? 'ganga' : null) ||
                    node.querySelector('[data-bi-label]')?.dataset?.biLabel ||
                    node.querySelector('.js-bi-label')?.innerText?.trim();
    
                products[productId] = {
                    timestamp: now,
                    label,
                    countryISO
                };
            });
            sendProductListEvent(products);
        } else {
            observeProducts(intersectionObserver);
            //en desktop el cambio de filtros provoca que se recargue una parte de la pagina solo
            const dynamicFilteringContainer = document.getElementById('filters-output');
            if(!dynamicFilteringContainer) {
                return;
            }

            const mutationObserver = new MutationObserver(
                () => {
                    //al renovarse la pagina, todos los productos que se estaban observando dejan de observarse y tb hay que chequear
                    const currentTime = new Date().getTime();
                    for (const productId in currentProducts) {
                        bufferCheck(currentTime, productId, intersectionObserver);
                        delete currentProducts[productId];
                    }
                    //Y añadir los nuevos, como hacemos con la paginacion
                    observeProducts(intersectionObserver);
                }
            );
            mutationObserver.observe(dynamicFilteringContainer, { childList : true });
        }
    });



}

initBIEventListeners();

export {
    track,
    trendView,
    getTrendView,
    trackProductView,
    currencyToCountryISO
}
